<template>
  <div class="school-package-select-dot-read">
    <titleBar :title="title" :callback="true" @callback="exit_event"></titleBar>
    <div class="grade">
      <span class="foundation-title">选择年级+学期</span>
      <div class="grade-list">
        <div
          v-for="(item, index) in data"
          :key="index"
          v-bind:class="gradeNameStyle(item)"
          v-on:click="changeBookList(index)"
        >{{ item.name }}</div>
      </div>
    </div>
    <div class="book-list">
      <div class="book-list-title">
        <span class="foundation-title">选择教材版本</span>
        <span class="foundation-subtitle">（人民教育出版社正版授权）</span>
      </div>
      <div class="product-list">
        <div
          v-for="(item, index) in productList"
          :key="index"
          v-bind:class="productStyle(item)"
          v-on:click="choseProduct(item)"
        >
          <div class="detail">
            <img class="book-img" :src="replaceBookCover(item.productId, item.icon)" />
            <div class="text">
              <span v-bind:class="bookNameStyle(item)">{{ item.book_name }}</span>
              <span v-bind:class="dayStyle(item)">180天</span>
            </div>
            <div class="purchased-tag" v-show="item.had_purchased_book">已购买</div>
          </div>
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="price">
        <span class="money-symbol">￥</span>
        <span class="sale-price">{{ Math.round(price) }}</span>
        <span class="origin-price">原价￥{{ originPrice }}</span>
      </div>
      <span class="pay" v-on:click="toPay">立即支付</span>
    </div>
    <p v-if="toast" class="toast">{{toast}}</p>
    <loading v-if="loading" :list="list" :loading="loading"></loading>
  </div>
</template>

<script>
import studentAjax from "@/api/studentAjax";
import utils from "@/assets/js/utils";
import titleBar from "@/components/common/titleBar.vue";
import loading from "@/components/common/loading.vue";
const payHost = {
  test: "https://betassweb.knowbox.cn:7001",
  preview: "https://prefe.knowbox.cn:7001",
  production: "https://ssweb.knowbox.cn"
}; 
window.verifyParentCallback = function() {
  window.location = "hybird://method/nativeToJS?funcName=callback";
};
let vm = null;
window.onVisible = function() {
  vm.getData();
};
export default {
  components: {
    titleBar,
    loading
  },
  data() {
    return {
      title: "选择课本",
      data: {},
      lastChosedGradeIndex: 0,
      productId: "0",
      productList: [],
      toast: "",
      price: 0,
      originPrice: 0,
      token: "",
      source: "",
      version: "",
      loading: true,
      list: true,
      packageProductId: "",
      bookCover: {
        "201":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_201.jpg",
        "202":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_202.jpg",
        "205":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_205.jpg",
        "206":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_206.jpg",
        "209":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_209.jpeg",
        "210":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_210.jpg",
        "211":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_211.jpg",
        "212":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_212.jpg",
        "217":
          "https://susuanqiniu.knowbox.cn/xin-jiao-cai-20190905_217new.jpeg",
        "218":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_218.jpg",
        "219":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_219.jpg",
        "220":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_220.jpg",
        "225":
          "https://susuanqiniu.knowbox.cn/xin-jiao-cai-20190905_225new.jpeg",
        "226":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_226.jpg",
        "227":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_227.jpg",
        "228":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_228.jpg",
        "233":
          "https://susuanqiniu.knowbox.cn/xin-jiao-cai-20190905_233new.jpeg",
        "234":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_234.jpg",
        "235":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_235.jpg",
        "236":
          "https://susuanqiniu.knowbox.cn/dian-du-ji-shang-ce-_20190903_236.jpg"
      }
    };
  },
  mounted() {
    vm = this;
    this.token = utils.getQueryString("token");
    this.source = utils.getQueryString("source");
    this.version = utils.getQueryString("version");
    this.price = utils.getQueryString("price");
    this.originPrice = utils.getQueryString("originPrice");
    this.packageProductId = utils.getQueryString("productId");
    this.getData();
  },
  methods: {
    exit_event: function() {
      this.$router.go(-1);
    },
    getData: async function() {
      const [resp] = await studentAjax.all([
        studentAjax.get("/html5/weekend-activity/get-dot-product-list", {
          params: {
            token: this.token,
            source: this.source,
            version: this.version
          }
        })
      ]);
      if (resp.data.code == 99999) {
        this.data = resp.data.data;
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].isChose) {
            this.lastChosedGradeIndex = i;
          }
        }
        this.productList = this.data[this.lastChosedGradeIndex].productList;
        this.defaultSelectBook(this.productList);
      }
      this.loading = false;
      this.list = false;
    },
    defaultSelectBook: function(productList) {
      for (let i = 0; i < productList.length; i++) {
        if (productList[i].had_purchased_book == 0) {
          this.productId = productList[i].productId;
          break;
        } else {
          this.productId = "0";
        }
      }
    },
    changeBookList: function(index) {
      this.data[index].isChose = 1;
      this.data[this.lastChosedGradeIndex].isChose = 0;
      this.lastChosedGradeIndex = index;
      this.productList = this.data[this.lastChosedGradeIndex].productList;
      this.defaultSelectBook(this.productList);
    },
    choseProduct: function(item) {
      if (item.had_purchased_book) {
        return;
      }
      this.productId = item.productId;
    },
    // 样式返回
    gradeNameStyle: function(item) {
      return item.isChose ? "name-selected" : "name-normal";
    },
    productStyle: function(item) {
      if (item.had_purchased_book) {
        return "product-purchased";
      }
      return item.productId === this.productId
        ? "product-selected"
        : "product-normal";
    },
    bookNameStyle: function(item) {
      if (item.had_purchased_book) {
        return "book-name-selected";
      }
      return item.productId === this.productId
        ? "book-name-selected"
        : "book-name-normal";
    },
    dayStyle: function(item) {
      if (item.had_purchased_book) {
        return "day-selected";
      }
      return item.productId === this.productId ? "day-selected" : "day-normal";
    },
    toPay: async function() {
      let self = this;
      if (this.productId === "0") {
        this.toast = "请选择赠送的课本";
        setTimeout(function() {
          self.toast = "";
        }, 1500);
      } else {
        const [resp] = await studentAjax.all([
          studentAjax.post("/html5/weekend-activity/save-dot-read-product", {
            token: this.token,
            source: this.source,
            version: this.version,
            productId: this.productId
          })
        ]);
        if (resp.data.code == 99999) {
          if (self.source.search("android") != -1) {
            window.location =
              "hybird://method/openPayment?productId=" +
              this.packageProductId +
              "&discountPrice=" +
              this.price +
              "&comeFrom=1" +
              "&withDiscount=false" +
              "&productName=【套餐1：语数英同步练各180天】" +
              "&productSubTitle=加赠一册点读机等5项学习产品" +
              "&comeFrom=23";
          } else {
            window.location = `${
              payHost[process.env.VUE_APP_INTER]
            }/h5-pay/dist/production/pay-final.html?token=${
              this.token
            }&source=${this.source}&version=${
              this.version
            }&payList=["wx_wap","alipay_wap"]&title=${encodeURIComponent(
              "【套餐1：语数英同步练各180天】"
            )}&subTitle=${encodeURIComponent(
              "加赠一册点读机等5项学习产品"
            )}&payPath=/ss/vip/pay-vip&verifyPath=/ss/vip/pay-verify&lastPay=wx_wap&productId=${
              this.packageProductId
            }&isShowMoney=2&isElephantCourse=0`;
          }
        } else {
          let self = this;
          self.toast = resp.data.msg;
          setTimeout(function() {
            self.toast = "";
          }, 1500);
        }
      }
    },
    replaceBookCover: function(productId, originImgUrl) {
      let imgUrl = this.bookCover[productId];
      if (imgUrl) {
        return imgUrl;
      } else {
        return originImgUrl;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.school-package-select-dot-read {
  background: #f2f5f7;
  height: 100vh;
  padding-top: 0.88rem;
  .foundation-title {
    font-family: PingFangSC-Semibold;
    font-size: 0.3rem;
    color: #262626;
  }
  .foundation-subtitle {
    font-family: PingFangSC-Regular;
    font-size: 0.22rem;
    color: #333333;
    margin-top: 0.06rem;
  }
  .grade {
    margin-top: 0.2rem;
    margin-left: 0.3rem;
    margin-right: 0.3rem;
    padding-top: 0.3rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    background: #fff;
    border-radius: 0.2rem;
    height: 2.6rem;
    display: flex;
    flex-direction: column;
    box-shadow: -1px 1px 5pt rgba(175, 176, 178, 0.25);
    .grade-list {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 0.3rem;
      .name-normal {
        width: 2rem;
        height: 0.6rem;
        border-radius: 0.3rem;
        border: solid 1px #eeeeee;
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #333333;
        text-align: center;
        line-height: 0.6rem;
        margin-bottom: 0.2rem;
      }
      .name-selected {
        background: #ff661f;
        width: 2rem;
        height: 0.6rem;
        border-radius: 0.3rem;
        font-family: PingFangSC-Regular;
        font-size: 0.26rem;
        color: #fff;
        text-align: center;
        line-height: 0.6rem;
        margin-bottom: 0.2rem;
      }
    }
  }
  .book-list {
    margin-top: 0.2rem;
    margin-left: 0.3rem;
    margin-right: 0.3rem;
    padding-top: 0.3rem;
    padding-left: 0.3rem;
    padding-right: 0.3rem;
    background: #fff;
    border-radius: 0.2rem;
    min-height: 2.26rem;
    display: flex;
    flex-direction: column;
    box-shadow: -1px 1px 5pt rgba(175, 176, 178, 0.25);
    .book-list-title {
      display: flex;
      flex-direction: row;
    }
    .product-list {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      flex-wrap: wrap;
      margin-top: 0.3rem;
      .product-normal {
        width: 3.06rem;
        height: 1.14rem;
        border: solid 1px #eeeeee;
        border-radius: 0.14rem;
        margin-bottom: 0.2rem;
        padding-left: 0.16rem;
      }
      .product-selected {
        background: #ff661f;
        width: 3.06rem;
        height: 1.14rem;
        border-radius: 0.14rem;
        margin-bottom: 0.2rem;
        padding-left: 0.16rem;
      }
      .product-purchased {
        background: #d9d9d9;
        width: 3.06rem;
        height: 1.14rem;
        border-radius: 0.14rem;
        margin-bottom: 0.2rem;
        padding-left: 0.16rem;
      }
    }
    .detail {
      display: flex;
      flex-direction: row;
      position: relative;
      .book-img {
        width: 0.6rem;
        height: 0.86rem;
        margin-left: 0.06rem;
        margin-top: 0.14rem;
      }
      .text {
        display: flex;
        flex-direction: column;
        padding-left: 0.3rem;
        padding-top: 0.28rem;
        .book-name-normal {
          font-family: PingFangSC-Regular;
          font-size: 0.26rem;
          color: #333333;
        }
        .book-name-selected {
          font-family: PingFangSC-Regular;
          font-size: 0.26rem;
          color: #fff;
        }
        .day-normal {
          width: 0.6rem;
          height: 0.24rem;
          font-family: PingFangSC-Medium;
          font-size: 0.16rem;
          color: #ffa811;
          border-radius: 0.12rem;
          border: solid 1px #ffa811;
          line-height: 0.22rem;
          text-align: center;
        }
        .day-selected {
          width: 0.6rem;
          height: 0.24rem;
          font-family: PingFangSC-Medium;
          font-size: 0.16rem;
          color: #fff;
          border-radius: 0.12rem;
          border: solid 1px #fff;
          line-height: 0.22rem;
          text-align: center;
        }
      }
      .purchased-tag {
        position: absolute;
        right: 0;
        top: 0;
        background: #ffa811;
        width: 0.72rem;
        height: 0.28rem;
        font-family: PingFangSC-Medium;
        font-size: 0.18rem;
        color: #fff;
        border-top-right-radius: 0.14rem;
        border-bottom-left-radius: 0.14rem;
        text-align: center;
      }
    }
  }
  .bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 1.2rem;
    background: #fff;
    border-top: solid 1px #dcdee0;
    display: flex;
    flex-direction: row;
    .price {
      width: 43%;
      height: 100%;
      line-height: 1.2rem;
      display: flex;
      flex-direction: row;
      .money-symbol {
        color: #ff661f;
        font-family: PingFangSC-Semibold;
        font-size: 0.36rem;
        margin-top: 0.08rem;
        margin-left: 10%;
      }
      .sale-price {
        color: #ff661f;
        font-family: PingFangSC-Semibold;
        font-size: 0.6rem;
      }
      .origin-price {
        color: #c8cacc;
        font-family: PingFangSC-Regular;
        font-size: 0.24rem;
        text-decoration: line-through;
        margin-top: 0.08rem;
        margin-left: 0.12rem;
      }
    }
    .pay {
      width: 57%;
      height: 100%;
      line-height: 1.2rem;
      background: #ff661f;
      font-family: PingFangSC-Semibold;
      font-size: 0.36rem;
      color: #fff;
      text-align: center;
    }
  }
  .toast {
    position: fixed;
    width: 3rem;
    height: 1.5rem;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    font-family: PingFangSC-Medium;
    font-size: 0.3rem;
    line-height: 1.5rem;
    text-align: center;
    color: #fff;
  }
}
/*iPhone X XS 2436x1125px at 458ppi */
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  .school-package-select-dot-read {
    padding-top: calc(0.88rem + constant(safe-area-inset-top));
    padding-top: calc(0.88rem + env(safe-area-inset-top));
    .bottom {
      bottom: constant(safe-area-inset-bottom);
      bottom: env(safe-area-inset-bottom);
    }
  }
}

/*iPhone XR 1792x828px at 326ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
  .school-package-select-dot-read {
    padding-top: calc(0.88rem + constant(safe-area-inset-top));
    padding-top: calc(0.88rem + env(safe-area-inset-top));
    .bottom {
      bottom: constant(safe-area-inset-bottom);
      bottom: env(safe-area-inset-bottom);
    }
  }
}

/* iPhone XS Max 2688x1242px at 458ppi */
@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  .school-package-select-dot-read {
    padding-top: calc(0.88rem + constant(safe-area-inset-top));
    padding-top: calc(0.88rem + env(safe-area-inset-top));
    .bottom {
      bottom: constant(safe-area-inset-bottom);
      bottom: env(safe-area-inset-bottom);
    }
  }
}
</style>
